import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Monitor } from "lucide-react";
import { useEffect, useState } from "react";
export default function DeviceRestriction({ children, }) {
    const [isPortraitMobileOrTablet, setIsPortraitMobileOrTablet] = useState(false);
    useEffect(() => {
        const checkDevice = () => {
            const width = window.innerWidth;
            const height = window.innerHeight;
            const isPortrait = height > width;
            const isMobileOrTablet = width < 1024; // Below 1024px is considered mobile/tablet
            // Show restriction only if it's mobile/tablet AND in portrait mode
            setIsPortraitMobileOrTablet(isMobileOrTablet && isPortrait);
        };
        checkDevice();
        window.addEventListener("resize", checkDevice);
        window.addEventListener("orientationchange", checkDevice);
        return () => {
            window.removeEventListener("resize", checkDevice);
            window.removeEventListener("orientationchange", checkDevice);
        };
    }, []);
    if (isPortraitMobileOrTablet) {
        return (_jsx("div", { className: "fixed inset-0 bg-background flex items-center justify-center p-6", children: _jsxs("div", { className: "text-center max-w-md", children: [_jsx("div", { className: "mb-6 flex justify-center", children: _jsx(Monitor, { className: "w-20 h-20 text-primary" }) }), _jsx("h1", { className: "text-2xl font-bold text-foreground mb-4", children: "Desktop View Required" }), _jsx("p", { className: "text-muted-foreground mb-6", children: "This application is optimized for desktop and landscape viewing. Please open it on a desktop computer or rotate your device to landscape mode for the best experience." }), _jsxs("div", { className: "flex flex-col gap-2 text-sm text-muted-foreground", children: [_jsx("p", { children: "Use a desktop or laptop" }), _jsx("p", { children: "Rotate your device to landscape" })] })] }) }));
    }
    return _jsx(_Fragment, { children: children });
}
